import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  gsap.registerPlugin( ScrollTrigger )
}

const documentReady = () => {
  
  const scrollComet = () => {
    let $comet = $('.comet')
    $comet.each( (i,obj) => {
      gsap.fromTo( obj, {
        x: '0',
      },
      {
        x: '-115vw',
        y: '199.18vw',
        // yPercent: 100 * parseFloat( obj.dataset.speed || 1 ),
        // xPercent: -100 * parseFloat( obj.dataset.speed || 1 ),
        scrollTrigger: {
          trigger: obj,
          start: `bottom ${obj.dataset.startAt}`, // the default values
          end: `+=${ parseFloat(obj.dataset.duration) * 100}px`,
          scrub: true, // アニメーションをスクロール位置にリンクさせる
          markers: (obj.dataset.marker == 'true'), // マーカー表示
          onEnter: () => $(obj).css('opacity',1).show(),
          onEnterBack: () => $(obj).css('opacity',1),
          onLeave: () => $(obj).hide(),
          onLeaveBack: () => $(obj).css('opacity',0)
        }
      })
    })
  }
  w.load['loadHtml'].then( scrollComet )

}

export default function COMET () {
  init()
  $( documentReady )
}